import { Injectable } from '@angular/core';
import { QuestionBase } from '@app/shared/survey-components/dynamic-form/question-base';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class QuestionControlService {
  constructor() { }

  toFormGroup(questions: Array<QuestionBase<string>>): UntypedFormGroup {
    const group: { [p: string]: AbstractControl } = {};
    questions.forEach(question =>
        group[question.key] = new UntypedFormControl(question.value || '', QuestionControlService.getValidatorsForQuestion(question)));
    return new UntypedFormGroup(group);
  }

  private static getValidatorsForQuestion(question: QuestionBase<string>): Array<ValidatorFn> {
    const validators = new Array<ValidatorFn>();
    if (question.required) {
      validators.push(Validators.required);
    }
    validators.push(Validators.minLength(question.minCharacters));
    validators.push(Validators.maxLength(question.maxCharacters));
    return validators;
  }
}
